import React from 'react';

export default class FooterRibbon extends React.Component {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <footer className="footer-ribbon">
        <div className="footer-ribbon-links">
          <a href="/internal/account/hub">The Hub</a>
          &nbsp;&nbsp; | &nbsp;&nbsp;
          <a href="/internal/account/site-map">Site Map</a>
        </div>

        <div className="footer-copyright">&#169; {currentYear} Recreation.gov. All Rights Reserved</div>
      </footer>
    );
  }
}
